import React from "react";

var SvgTriMet = function SvgTriMet() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100.3 100.29",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M100.3,50.15A50.15,50.15,0,1,1,50.15,0,50.15,50.15,0,0,1,100.3,50.15",
    style: {
      fill: "#e0651f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M61.62,58.06A22.49,22.49,0,1,1,72.83,38.59",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "6.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M50.88,37.61a22.49,22.49,0,1,1-22.32.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "6.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M38.17,57.17A22.49,22.49,0,1,1,49.41,76.73",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "6.08px"
    }
  }));
};

export default SvgTriMet;
//# sourceMappingURL=TriMet.js.map